export enum SelectType {
  SIDE,
  MODAL,
  OVERLAY,
}
